import ShapeFactory from './Shapes/ShapeFactory.js';
import {setActiveShapeStyle} from './DrawingUtil.js';
class DrawingCanvas {
    constructor(canvas,fabricCanvas  ,{ onCanvasObjectUpdated, onCanvasTextEditEntered } = {}, onObjectSelection = () => {}, onSelectionCleared= ()=> {}, onObjectModifying = ()=>{}) {
        this.canvas = canvas;
        this.objectAdded = null;
        this.objectUpdated = onCanvasObjectUpdated;
        this.textEditEntered = onCanvasTextEditEntered;
        this.mouseDown = null;
        this.mouseMove = null;
        this.mouseUp = null;
        this.removeEvents = this.removeEvents;
        this.registerEvents = this.registerEvents;
        this.origX = 0;
        this.origY = 0;
        this.onObjectSelection = onObjectSelection;
        this.onSelectionCleared = onSelectionCleared; 
        this.onObjectModifying = (event) => {            
            this.restrictToBoundingBox(event);                    
            onObjectModifying(event);
        };

        //init canvas with Selection Off to avoid free drawing selection bug
        this.fabricCanvas = fabricCanvas;
        this.fabricCanvas.defaultCursor = `inherit`;        
        this.wireCanvasEvents();
    }

    removeEvents() {
        var _this = this;
        this.fabricCanvas.off('mouse:down');
        this.fabricCanvas.off('mouse:move');
        this.fabricCanvas.off('mouse:up');
        this.fabricCanvas.off('object:added');
    }
    wireCanvasEvents() {
        var _this = this;
        this.removeEvents();
        this.fabricCanvas.off('object:modified');
        this.fabricCanvas.off('text:editing:entered');
        this.fabricCanvas.off('text:editing:exited');

        this.fabricCanvas.on({
            'object:modified': (e) => {
                _this.objectUpdated && _this.objectUpdated(e);
            }
        });

        this.fabricCanvas.on({
            'object:added': (e) => {
                _this.objectAdded && _this.objectAdded(e);
            }
        });

        this.fabricCanvas.on({
            'mouse:down': (event) => {
                if (_this.mouseDown) {
                    const pointer = _this.fabricCanvas.getPointer(event.e);
                    const points = [pointer.x, pointer.y, pointer.x, pointer.y];
                    [this.origX, this.origY] = points;
                    _this.mouseDown(points);
                }
            }
        });

        this.fabricCanvas.on({
            'mouse:move': (event) => {
                const pointer = _this.fabricCanvas.getPointer(event.e);
                const activeObj = _this.fabricCanvas.getActiveObject();

                let shouldRespond = false;

                if  (event.e.type === "mousemove") {
                    shouldRespond = activeObj && event.e && event.e.buttons && event.e.buttons === 1;
                }
                else if (event.e.type === "touchmove") {
                    shouldRespond = activeObj && event.e && event.e.touches && event.e.touches.length === 1;
                }

                if (shouldRespond) {
                    activeObj.set({
                        x2: pointer.x,
                        y2: pointer.y
                    });

                    activeObj.setCoords();
                                        

                    _this.fabricCanvas.renderAll();
                }
                if (_this.mouseMove) {
                    _this.mouseMove(pointer);
                }
            }
        });

        this.fabricCanvas.on({
            'mouse:up': (e) => {
                _this.mouseUp && _this.mouseUp(e);
            }
        });

        this.fabricCanvas.on('text:editing:entered', function (e) {
            _this.textEditEntered && _this.textEditEntered(true, e.target.showPlaceholder);
        });

        this.fabricCanvas.on('text:editing:exited', function (e) {
            _this.textEditEntered && _this.textEditEntered(false, e.target.showPlaceholder);
        });

        this.fabricCanvas.on({
            'selection:updated': this.onObjectSelection,
            'selection:created': this.onObjectSelection
          });

        this.fabricCanvas.on({
          'selection:cleared': this.onSelectionCleared           
        });

        this.fabricCanvas.on({
            'object:rotating': this.onObjectModifying,
            'object:scaling': this.onObjectModifying,
            'object:moving': this.onObjectModifying,
            'object:skewing': this.onObjectModifying,           
        });        
    }

    restrictToBoundingBox(event) {
        var obj = event.target;
        // if object is too big ignore

        if (event === null || event === undefined || obj === null || obj === undefined) {
            return;
        } 
            
        obj.setCoords();
        // top-left  corner
        let borderOffset = 10;
        if (obj.getBoundingRect().top < 0 + borderOffset
            || obj.getBoundingRect().left < 0 + borderOffset) {
            obj.top = Math.max(obj.top, obj.top - obj.getBoundingRect().top);
            obj.left = Math.max(obj.left, obj.left - obj.getBoundingRect().left);
        }
        // bot-right corner
        if (obj.getBoundingRect().top + obj.getBoundingRect().height > obj.canvas.height
            || obj.getBoundingRect().left + obj.getBoundingRect().width > obj.canvas.width) {
            obj.top = Math.min(obj.top, obj.canvas.height - obj.getBoundingRect().height + obj.top - obj.getBoundingRect().top);
            obj.left = Math.min(obj.left, obj.canvas.width - obj.getBoundingRect().width + obj.left - obj.getBoundingRect().left);
        }
    }

    registerEvents(events) {
        const {
            onCanvasMouseDown,
            onCanvasMouseUp,
            onCanvasMouseMove,
            onCanvasObjectAdded
        } = events;
        this.mouseDown = onCanvasMouseDown;
        this.mouseUp = onCanvasMouseUp;
        this.mouseMove = onCanvasMouseMove;
        this.objectAdded = onCanvasObjectAdded;
        this.wireCanvasEvents();
    }
    initFreeHand(color) {
        var canvas = this.fabricCanvas;
        if (canvas.isDrawingMode === true) {
            canvas.freeDrawingBrush = new fabric.PencilBrush(canvas);
            canvas.freeDrawingBrush.color = color;
            canvas.freeDrawingBrush.width = 5;
        }
    }

    toggleDrawingMode(enable) {
        this.fabricCanvas.isDrawingMode = enable;
    }

    remove(canvasObject) {
        this.fabricCanvas && this.fabricCanvas.remove(canvasObject);
    }

    removeObjectById(id) {
        const canvasObject = this.fabricCanvas.getObjects().filter((item) => {
            return item.uuid === id;
        })[0];
        this.remove(canvasObject);
        this.toggleDrawingMode(false);
    }
    getObjectById(id) {
        const canvasObject = this.fabricCanvas.getObjects().filter((item) => {
            return item.uuid === id;
        })[0];
        return canvasObject;
    }


    selectObjectById(id) {
        
        const canvasObject = this.fabricCanvas.getObjects().filter((item) => {
            return item.uuid === id;
        })[0];
        if(!canvasObject) { return };

        this.fabricCanvas.setActiveObject(canvasObject);
        this.renderAll();
    }

    selectMultipleById(ids) {
        const canvasObject = this.fabricCanvas.getObjects().map((item) => {
            return  ids.some(x => item.uuid);
        })[0];

        
        
        this.fabricCanvas.setActiveObject(canvasObject);
        this.renderAll();
    }


    clear() {
        this.fabricCanvas && this.fabricCanvas.clear();
    }

    renderAll() {
        this.fabricCanvas && this.fabricCanvas.renderAll();
    }

    drawShape(shapeProps) {        
        const shape = ShapeFactory.createShape({ ...shapeProps, drawingCanvas: this });       
        shape.draw(shapeProps, this);
    }

    setActiveShape(shape) {
        setActiveShapeStyle(shape);
        this.fabricCanvas.setActiveObject(shape);        
    }

    getActiveShape() {
        return this.fabricCanvas.getActiveObject();
    }
    add(shape) {                
        setActiveShapeStyle(shape);        
        this.fabricCanvas.add(shape);
    }
    addAsActiveShape(shape) {
        setActiveShapeStyle(shape);  
        this.fabricCanvas.add(shape).setActiveObject(shape);
    }
    removeShape(shape) {
        this.fabricCanvas.remove(shape);
    }

    setBackgroundImage(img) {
        this.fabricCanvas && this.fabricCanvas.setBackgroundImage(img);
    }
    addCommentImageStamp(canvasObject) {
        let _this = this;
        fabric.Image.fromURL('../assets/Objects/Note.png', function (img) {
            var oImg = img.set({ left: 5, top: 5, selectable:false });
            _this.fabricCanvas.add(oImg);
        });
    }
    clearSelection() {
        this.fabricCanvas.discardActiveObject();
        this.fabricCanvas.requestRenderAll();
    }
}

export { DrawingCanvas };
